import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SfxBtn from "src/components/button/SfxBtn.vue"

//region Props and Emits

// If the button's flat design is not desired in some cases,
// a prop can be defined to make it possible to disable it.
// Note: If the flat prop is disabled, a color for the button
// (and maybe for its text) should be specified.


export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'SfxBtnIcon',
  props: {
  icon: {
    type: String,
    required: true,
  },

  class: {
    type: String,
  },

  color: {
    type: String,
  },

  textColor: {
    type: String,
  },

  size: {
    type: String,
    default: "lg",
  },

  padding: {
    type: String,
  },

  disable: {
    type: Boolean,
    default: false,
  },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit



//endregion

//region Functions

function handleClick(event: Event) {
  // Adding event allows for emit modifiers like "stop, once, etc." to be used
  emit("click", event)
}

//endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SfxBtn, _mergeProps({
    flat: "",
    dense: "",
    round: "",
    icon: props.icon,
    class: props.class,
    color: props.color,
    "text-color": props.textColor,
    size: props.size,
    padding: props.padding,
    disable: props.disable,
    onClick: handleClick
  }, _ctx.$attrs), _createSlots({ _: 2 }, [
    (_ctx.$slots.default)
      ? {
          name: "default",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots.loading)
      ? {
          name: "loading",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "loading")
          ]),
          key: "1"
        }
      : undefined
  ]), 1040, ["icon", "class", "color", "text-color", "size", "padding", "disable"]))
}
}

})